import React from "react"
// react component for creating dynamic tables
import ReactTable from "react-table"

import * as Alert from "alertService"
import { APIPost, APIGet } from "services/APIRequest"
import UrlServer from "configs/UrlServer"
import { ErrorsCallback, SuccessCallback } from "alertService"
import { thaiBath } from "helpers/ConvertFormat"

import { compose } from "recompose"
import { connect } from "react-redux"
import { listsQualityDataUpdate } from "store/actions"

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles"
// @material-ui/icons
import FormatListNumberedIcon from "@material-ui/icons/FormatListNumbered";
import EventNoteIcons from "@material-ui/icons/EventNote"
// import Dvr from "@material-ui/icons/Dvr";
// import Favorite from "@material-ui/icons/Favorite";
import DeleteForeverIcons from "@material-ui/icons/DeleteForever"
// core components
import GridContainer from "components/Grid/GridContainer"
import GridItem from "components/Grid/GridItem"
import Button from "components/CustomButtons/Button"
import Card from "components/Card/Card"
import CardBody from "components/Card/CardBody"
import CardIcon from "components/Card/CardIcon"
import CardHeader from "components/Card/CardHeader"
import Select from "components/CustomSelects/Select"
import Switch from "@material-ui/core/Switch"
import Badge from "components/Badge/Badge"
import Tooltip from "@material-ui/core/Tooltip";

import { cardTitle } from "assets/jss/material-dashboard-pro-react"

import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle"
import tasksStyle from "assets/jss/material-dashboard-pro-react/components/tasksStyle";
const styles = {
  ...extendedFormsStyle,
  ...tasksStyle,
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  noConfirmedemail: {
    color: "red"
  },
  devType: {
    color: "#689F38"
  },
  tableH: { 
  }
}
class UserFromImportListManagement extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      statusWaitingUpdate: true,
      dataListRaw: [],
      dataList: []
    }
  }
  componentDidMount() { 
    this.props.listsQualityDataUpdate()
  }

  componentWillUpdate(nextProps, nextState) { 
    if (nextProps.listsQualityData !== nextState.dataListRaw) {
      var dataList = this.renderListData(nextProps)
      this.setState({
        statusWaitingUpdate: false,
        dataListRaw: nextProps.listsQualityData,
        dataList: dataList
      },()=>{
        Alert.LoadingClose()
        this.props.callbacksetTabIndex(0)
      })
    }
  }
  handleUserViewDetail = (indexData)=>{
    this.props.callbacksetTabIndex(1)
    this.props.callbackSetCurrentData(this.state.dataListRaw[indexData])
  }
   
  renderListData = data => {
    return data.listsQualityData.map((CData, key) => {
      return {
        no: (key + 1),
        dealercode: CData.dealer_code,
        data: (<div> {CData.data}</div>), 
        actions: (
          <div className="actions-right">
             
          </div>
        )
      }
    })
  }
   
  render() {
    const { classes } = this.props
    return (
      <div className={"card-space"}>
        <GridContainer >
          <GridItem xs={12}>
            <Card >
              <CardHeader color="info" icon>
                <CardIcon color="info">
                  <FormatListNumberedIcon />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>รายการ Quality Data นำเข้าระบบโดยการ Import</h4>
              </CardHeader>
              <CardBody>
                <span>จำนวน {thaiBath(this.state.dataList.length,false)} รายการ</span> 
                <ReactTable
                  className="table-scroll"
                  data={this.state.dataList}
                  filterable
                  columns={[
                    {
                      Header: "No.",
                      accessor: "no",
                      width: 80
                    },
                    {
                      Header: "Dealer-Code",
                      accessor: "dealercode",
                      width: 150
                    },
                    {
                      Header: "Data",
                      accessor: "data",
                    }, 
                    {
                      Header: "ตั้งค่าต่างๆ",
                      accessor: "actions",
                      sortable: false,
                      filterable: false,
                      width: 100
                    }
                  ]}
                  defaultPageSize={10}
                  showPaginationTop
                  showPaginationBottom={false}
                  className="-striped -highlight"
                />
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    )
  }
}

function mapStateToProps({ listsQualityData }) {
  return {
    listsQualityData: listsQualityData
  }
}

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    { listsQualityDataUpdate }
  )
)(UserFromImportListManagement)
